import { AccelFile } from "@axl/membership-sdk";
import { Popover, Typography } from "antd";
import { FC, PropsWithChildren } from "react";

import { useLoc } from "@app/shared/lib/hooks";

import Comment from "../../Comment/Comment";

type FileDescriptionTooltipProps = {
  file: AccelFile;
  canEdit?: boolean;
  onSave: (description: string) => Promise<boolean>;
};

export const FileDescriptionPopover: FC<
  PropsWithChildren<FileDescriptionTooltipProps>
> = ({ file, canEdit, onSave, children }) => {
  const loc = useLoc();

  return (
    <Popover
      content={
        <Comment
          text={file.description}
          emptyText={
            <Typography.Text type="secondary">
              {loc.word("FileList.emptyDescriptionMsg", {
                default: "No description",
              })}
            </Typography.Text>
          }
          disableFiles
          placeholder={loc.word("FileList.descriptionPlaceholder", {
            default: "Enter description",
          })}
          onSend={async (text) => onSave?.(text)}
          canRemove={false}
          canEdit={canEdit}
        />
      }
      title={loc.word("Description")}
      trigger="hover"
    >
      {children as React.ReactElement}
    </Popover>
  );
};
